<template>
    <div class="news">
        <banner title="核心产品"/>
        <div class="news-section">
            <div class="news-section-content">
                <div class="content-summary">
                    <div class="summary-left">
                        <p class="title">产品简介</p>
                        <p class="content" style="margin-top: 10px">
                            公司的核心产品《店慧通》App，经过8年多的不断迭代升级，无论专业度、成熟度、易用性、系统稳定性等各个方面都达到了较高的水准，赢得了很多客户的一致好评！
                        </p>
                        <p class="eTitle">通过《店慧通》可以帮助企业快速达到如下成效：
                        </p>
                        <p class="content" style="text-indent: 0px;margin-left: 25px">
                            1、快速建立一套统一的数据分析标准，确保各部门数据口径一致，提升决策速度<br/>
                            2、快速建立一套单店业绩诊断标准，深度挖掘销售提升机会<br/>
                            3、快速建立一套移动零售追踪平台，各级管理层可以随时随地实现零售移动管理<br/>
                            4、为管理层巡店提供一套完整及时的数据依据，快速提升巡店检查效果<br/>
                            5、为会员管理提供了一套科学精准、易于执行的落地方案，快速实现会员转化<br/>
                            6、为零售终端实现货品的快速周转，提供了简单有效的执行方法，可以大幅提升库存效率<br/>
                            7、零售部门各个岗位，不再需要依赖其他部门提供专业的分析报表，即可自行进行快速应变
                        </p>
                    </div>
                    <div class="summary-right" style="display: none">
                        <p style="margin-top: 10px">请用扫一扫下载APP</p>
                        <img src="../assets/img/dappcode.png" alt/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Banner from "../components/Banner";

    export default {
        name: "news",
        components: {
            Banner
        },
        data() {
            return {
                loading: true,
                newsList: [],
                newstype: 1
            };
        },
        methods: {
            loadData() {
                this.loading = true;
                this.$http
                    .get(`News?type=${this.newstype}&num=6`)
                    .then(response => {
                        //console.log(response);
                        this.newsList = response.data;
                        this.loading = false;
                        //window.console.log(this.newsList);
                    })
                    .catch(function (error) {
                        window.console.log(error);
                    });
            }
        },
        mounted() {
            this.loadData();
        },
        watch: {
            newstype(type) {
                window.console.log(type);
                this.loadData();
            }
        }
    };
</script>

<style lang="scss" scoped>
    * {
        margin: 0;
        padding: 0;
    }

    .news {
        width: 100%;
        height: 100%;
        background-color: #1D2643;
        position: relative;
        overflow: hidden;

        &-section {
            width: 100%;
            //height: 1600px;

            &-content {
                width: 1240px;
                //height: 1600px;
                margin: 0 auto;
                background-color: #fff;
                border: 1px solid red;

                .content-summary {
                    //height: 500px;
                    display: flex;
                    justify-content: space-around;
                    padding: 100px 0;

                    .summary-left {
                        width: 600px;

                        .title {
                            font-size: 25px;
                            color: #e13834;
                        }

                        .eTitle {
                            font-size: 17px;
                            color: #e13834;
                            padding: 20px 0;
                        }

                        .content {
                            color: #14679f;
                            font-size: 14px;
                            text-indent: 25px;
                            line-height: 30px;
                        }
                    }

                    .summary-right {
                        width: 400px;
                        height: 310px;
                        border: 2px solid #1d42b9;
                        //animation: imgboxkey 4s infinite;
                        border-radius: 10px;
                        margin-top: 80px;
                        text-align: center;

                        img {
                            width: 200px;
                            height: 210px;
                            margin-top: 20px;
                            //animation: imgbo 4s infinite;
                        }
                    }
                }


                .content-nav {
                    width: 400px;
                    height: 55px;
                    margin: 0 auto;
                    display: flex;
                    //justify-content: center;
                    align-items: center;
                    position: relative;
                    bottom: 30px;
                    border: 1px solid red;

                    &-btn {
                        width: 50%;
                        height: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        background-color: #e4e4e4;
                        transition: all 0.2s;
                    }

                    .content-nav-active {
                        background-color: red;
                        color: #fff;
                    }
                }

                .content-nav-item {
                    width: 1070px;
                    margin: 0 auto;
                    display: flex;
                    justify-content: flex-start;
                    flex-wrap: wrap;
                    //border: 1px solid blue;

                    .item-list {
                        width: 330px;
                        height: 500px;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        margin: 10px 10px;
                        border: 1px solid #15669e;

                        &:hover {
                            border: 1px solid #fff;
                            box-shadow: 0 0 5px 2px #bfd3e0;
                        }

                        .item-img {
                            width: 300px;
                            height: 210px;
                            background-color: #cecece;
                            background-repeat: no-repeat;
                            background-size: cover;
                            background-position: center;
                            background-origin: content-box;
                        }

                        &-title {
                            width: 300px;
                            height: 60px;
                            color: #15669e;
                            font-size: 22px;
                            padding: 0 10px;
                            margin: 20px 0;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            border-left: 1px solid #15669e;
                        }

                        &-content {
                            width: 273px;
                            height: 100px;
                            font-size: 14px;
                            color: gray;

                            // 文本长度处理 begin
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 5;
                            -webkit-box-orient: vertical;
                            white-space: normal !important;
                            word-wrap: break-word;
                            // 文本长度处理 ending
                        }

                        &-more {
                            width: 273px;
                            padding-top: 20px;
                            display: flex;
                            justify-content: flex-start;
                            align-items: center;

                            img {
                                width: 12px;
                                height: 12px;
                            }

                            span {
                                color: #e13834;
                                padding: 0 5px;
                            }
                        }
                    }
                }
            }
        }

        .text-decoration {
            text-decoration: none;
        }
    }
</style>
